__turbopack_context__.v({
  "badge": "QciRyG_badge",
  "closeButton": "QciRyG_closeButton",
  "error": "QciRyG_error",
  "icon": "QciRyG_icon",
  "info": "QciRyG_info",
  "label": "QciRyG_label",
  "lg": "QciRyG_lg",
  "md": "QciRyG_md",
  "neutral": "QciRyG_neutral",
  "primary": "QciRyG_primary",
  "removable": "QciRyG_removable",
  "secondary": "QciRyG_secondary",
  "sm": "QciRyG_sm",
  "square": "QciRyG_square",
  "success": "QciRyG_success",
  "warning": "QciRyG_warning",
  "xs": "QciRyG_xs",
});
